/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HeadingInputs */

const en_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heading`)
};

const es_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encabezado`)
};

const fr_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre`)
};

const de_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überschrift`)
};

const ja_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見出し`)
};

const zh_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题`)
};

const ar_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العنوان`)
};

const id_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tajuk`)
};

const it_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intestazione`)
};

const ru_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок`)
};

const pt_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const ko_heading = /** @type {(inputs: HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제목`)
};

/**
* | output |
* | --- |
* | "Heading" |
*
* @param {HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const heading = /** @type {((inputs?: HeadingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HeadingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_heading(inputs)
	if (locale === "es") return es_heading(inputs)
	if (locale === "fr") return fr_heading(inputs)
	if (locale === "de") return de_heading(inputs)
	if (locale === "ja") return ja_heading(inputs)
	if (locale === "zh") return zh_heading(inputs)
	if (locale === "ar") return ar_heading(inputs)
	if (locale === "id") return id_heading(inputs)
	if (locale === "it") return it_heading(inputs)
	if (locale === "ru") return ru_heading(inputs)
	if (locale === "pt") return pt_heading(inputs)
	return ko_heading(inputs)
});